import { render, staticRenderFns } from "./vue-fab.vue?vue&type=template&id=b12d845a&scoped=true"
import script from "./vue-fab.vue?vue&type=script&lang=js"
export * from "./vue-fab.vue?vue&type=script&lang=js"
import style0 from "./vue-fab.vue?vue&type=style&index=0&id=b12d845a&prod&lang=scss"
import style1 from "./vue-fab.vue?vue&type=style&index=1&id=b12d845a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12d845a",
  null
  
)

export default component.exports